import { useNavigate, useLocation } from "react-router-dom";

export const useSectionNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (id, cb) => {
    if (location.pathname === "/") {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#" + id);
    }
    if (cb) cb();
  };
};
